import { createContext } from "react";

export const MarginHitContext = createContext({
  isTopMarginHit: false,
  isBottomMarginHit: false,
  isLeftMarginHit: false,
  isRightMarginHit: false,
  hitMargin: () => {},
});
